<template>
  <a-form-model-item prop="store" :colon="false" has-feedback>
    <span slot="help" class="text-dark"></span>
    <span slot="label" class="text-dark">{{$t('store')}}</span>
    <a-select
      v-model="selected"
      @change="onChange"
      :loading="loading"
      size="large">
      <a-select-option
        v-for="item in stores"
        :key="item.id"
        :value="item.address.code">
        {{item.name}}
      </a-select-option>
    </a-select>
  </a-form-model-item>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import lms from '@/api/lms'
export default {
  props: [
    'value',
    'owner',
  ],
  data() {
    return {
      loading: false,
      selected: undefined,
      stores: [],
    }
  },
  watch: {
    owner: {
      deep: false,
      immediate: true,
      handler: 'init',
    },
  },
  computed: {
    store() {
      // set the current store if defined
      if (this.value) {
        return this.stores.find(s => s.address.code === this.value.address.code)
      }
      // set the main store if defined
      if (this.stores.length) {
        return this.stores.find(s => s.main)
      }
      return undefined
    },
  },
  methods: {
    init() {
      if (this.owner) {
        this.loading = true
        lms.account.fetchStores(this.owner)
          .then(r => {
            this.stores = r.data.data
            if (this.store) {
              this.selected = this.store.address.code
              this.$emit('input', cloneDeep(this.store))
            } else {
              this.selected = null
              this.$emit('input', null)
            }
          }).finally(() => (this.loading = false))
      }
    },
    onChange(code) {
      const store = this.stores.find(s => s.address.code === code)
      this.$emit('input', cloneDeep(store))
    },
  },
}
</script>
